<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @getTableData="getTableData" @btnclick="bthClick"
                :pageData="pageData"
    ></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
    <statistics :tableData="tableData" :totalize="totalize" ref="statistics"></statistics>
    <el-dialog
      :title="$t('txmis.rewardDealList.cancelProposal')"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-input type="textarea" :rows="4" :placeholder="$t('txmis.rewardDealList.reason')" maxlength="100"
                show-word-limit v-model="reason"
      ></el-input>
      <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('txmis.rewardDealList.cancel') }}</el-button>
      <el-button type="primary" @click="cancel">{{ $t('txmis.rewardDealList.confirm') }}</el-button>
     </span>
    </el-dialog>
  </div>
</template>

<script>
//table封装组件
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import UPDATE from '@/components/page/update.vue'
import statistics from '../rebate/components/statistics.vue'
import download from '@/utils/download'
import Qs from 'qs'
import URL from '@/views/newmis36/util/url'
import DateUtil from '@/utils/IM/tradeDataUtil.js'

let proposalStatus = { '0': '待提交', '1': '待审批', '2': '已成功', '3': '已取消' }
let customerStatus = { 0: '禁用', 1: '启用', 2: '注销' }
let nationality = { 'ISO_3166_704': '越南', 'ISO_3166_356': '印度' }
let startTime = new Date().format('yyyy-MM-dd')
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE,
    statistics
  },
  methods: {
    checkbox(row) {
      this.ids = row.map(key => key.id).join(',')
      this.proposals = row.map(key => key.proposalStatus).join(',')
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'update') {
        this.$refs.childUpdate.open(row)
      }
    },
    getTableData(tableData) {
      this.tableData = tableData
      this.getTotalAmount()
    },
    /*总计*/
    getTotalAmount() {
      const param = Object.assign(JSON.parse(JSON.stringify(this.queryData)), {})
      this.$axios.get(URL.depositDetails.getTotalAmount, {
        params: param
      }).then((res) => {
        if (res.code == 0) {
          this.totalize = res.result
        } else {
          console.log(res.message)
        }
      }).catch(function(error) {
        console.log(error)
      })
    },
    judge() {
      if (!this.proposals && this.proposals.length <= 0) {
        this.$message({
          message: window.$t('txmis.accountReward.choiceOne'),
          type: 'warning'
        })
        return false
      }
      if ((this.proposals.indexOf('1') != -1) || this.proposals.indexOf('2') != -1 || this.proposals.indexOf('3') != -1) {
        this.$message({
          message: window.$t('txmis.accountReward.notSatisfiable'),
          type: 'warning'
        })
        return false
      }
      return true
    },
    cancel() {
      this.dataChanage(URL.depositDetails.cancelProposal, { ids: this.ids, reason: this.reason }, res => {
        this.handleClose()
        if (res.code == 0) {
          this.$message.success(window.$t('txmis.accountReward.applySuccess'))
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(window.$t('txmis.accountReward.applyFail'))
        }
      })
    },
    handleClose() {
      this.reason = ''
      this.dialogVisible = false
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if ('查询' == clickName || window.$t('txmis.bt.query') == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if (window.$t('txmis.rewardDealList.confirmSubmit') == clickName) {
        //校验
        if (!this.judge()) {
          return
        }
        this.dataChanage(URL.depositDetails.submitProposal, { ids: this.ids }, res => {
          if (res.code == 0) {
            this.$message.success(window.$t('txmis.accountReward.applySuccess'))
            this.$refs.childTable.defaultGetData(this.queryData)
          } else {
            this.$message.error(window.$t('txmis.accountReward.applyFail'))
          }
        })
      } else if (window.$t('txmis.rewardDealList.cancel') == clickName) {
        //校验
        if (!this.judge()) {
          return
        }
        this.dialogVisible = true

      } else if (window.$t('txmis.bt.down') == clickName) {
        //隐藏关键字段
        const param = Object.assign(JSON.parse(JSON.stringify(data)), { exportHide: true })
        download.exportExcel(URL.depositDetails.downloadList, param, 'details')
      } else if (window.$t('txmis.bt.export') == clickName) {
        const param = Object.assign(JSON.parse(JSON.stringify(data)), {})
        download.exportExcel(URL.depositDetails.downloadList, param, 'details')
      }
    },
    /*新增或跟提交数据触发事件*/
    submit(model) {
      //根据是否包含id更新还是添加
      this.dataChanage(URL.depositDetails.edit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success(window.$t('txmis.rewardDealList.confirmSuccess'))
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.success(window.$t('txmis.rewardDealList.confirmFail'))
        }
      })
    },
    dataChanage(url, option, suc, fail) {
      this.axios.post(url, Qs.stringify(option || {})).then(res => {

        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }
  },
  mounted() {

  },
  data() {
    return {
      ids: '',
      proposals: '',
      reason: '',
      dialogVisible: false,
      queryData: {},
      tableData: [],
      totalize: {},
      /*新增或更新*/
      updateData: {
        cols: [
          { title: '', field: 'id', hidden: true },
          {
            title: window.$t('txmis.rewardDealList.currentCustomerNumber'),
            field: 'currentCustomerNumber',
            disabled: true
          },
          { title: window.$t('txmis.rewardDealList.currentMobilePhone'), field: 'currentMobilePhone', disabled: true },
          { title: window.$t('txmis.rewardDealList.currentChineseName'), field: 'currentChineseName', disabled: true },
          {
            title: window.$t('txmis.rewardDealList.customerStatus'),
            field: 'customerStatus',
            type: 2,
            optionList: customerStatus,
            isNumber: true,
            disabled: true
          },
          { title: window.$t('txmis.rewardDealList.currentRebete'), field: 'currentRebete', disabled: true },
          { title: window.$t('txmis.rewardDealList.correctionRebete'), field: 'correctionRebete', disabled: true },
          { title: window.$t('txmis.rewardDealList.finalRebete'), field: 'finalRebete' },
          { title: '类型', field: 'activeType', data: 1, hidden: true }
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {
            title: window.$t('txmis.common.startTime'),
            field: 'beginDate',
            type: 5,
            dateType: 'date',
            format: 'yyyy-MM-dd',
            data: startTime
          },
          {
            title: window.$t('txmis.common.endTime'),
            field: 'endDate',
            type: 5,
            dateType: 'date',
            format: 'yyyy-MM-dd',
            data: startTime
          },
          { title: window.$t('txmis.rewardDealList.currentCustomerNumber'), field: 'currentCustomerNumber' },
          { title: window.$t('txmis.rewardDealList.currentMobilePhone'), field: 'currentMobilePhone' },
          {
            title: window.$t('txmis.rewardDealList.customerStatus'),
            field: 'customerStatus',
            type: 2,
            optionList: customerStatus
          },
          {
            title: window.$t('txmis.rewardDealList.proposalStatus'),
            field: 'proposalStatus',
            type: 2,
            optionList: proposalStatus
          },
          {
            title: window.$t('txmis.relationList.nationality'),
            field: 'nationality',
            type: 2,
            optionList: nationality
          },
          { title: '类型', field: 'activeType', data: 1, hidden: true },
          { title: '数据类型', field: 'isproposal', data: 0, hidden: true },
          { click: window.$t('txmis.bt.query') },
          { click: window.$t('txmis.bt.down') },
          { click: window.$t('txmis.bt.export') },
          { click: window.$t('txmis.rewardDealList.confirmSubmit') },
          { click: window.$t('txmis.rewardDealList.cancel') }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: URL.depositDetails.list, //请求路径和参数
        selection: true,
        sequence: true,
        cols: [
          { title: window.$t('txmis.rewardDealList.createDate'), field: 'createDate' },
          { title: window.$t('txmis.rewardDealList.currentCustomerNumber'), field: 'currentCustomerNumber' },
          { title: window.$t('txmis.rewardDealList.currentMobilePhone'), field: 'currentMobilePhone' },
          { title: window.$t('txmis.rewardDealList.currentChineseName'), field: 'currentChineseName' },
          {
            title: window.$t('txmis.relationList.nationality'), field: 'excuteNationality', render: (data, full) => {
              return nationality[data]
            }
          },
          {
            title: window.$t('txmis.rewardDealList.customerStatus'), field: 'customerStatus', render: (data, full) => {
              return customerStatus[data] || ''
            }
          },
          { title: window.$t('txmis.rewardDealList.currentRebete'), field: 'currentRebete' },
          { title: window.$t('txmis.rewardDealList.correctionRebete'), field: 'correctionRebete' },
          { title: window.$t('txmis.rewardDealList.finalRebete'), field: 'finalRebete' },
          {
            title: window.$t('txmis.rewardDealList.proposalStatus'), field: 'proposalStatus', render: (data, full) => {
              return proposalStatus[data] || ''
            }
          },
          { title: window.$t('txmis.rewardDealList.updateUser'), field: 'updateUser' },
          { title: window.$t('txmis.rewardDealList.updateDate'), field: 'updateDate' },
          { title: window.$t('txmis.rewardDealList.approvalUser'), field: 'approvalUser' },
          { title: window.$t('txmis.rewardDealList.approvedDate'), field: 'approvedDate' },
          { title: window.$t('txmis.rewardDealList.remark'), field: 'remark' },
          {
            field: window.$t('txmis.bt.edit'),
            title: window.$t('txmis.bt.operation'),
            size: 'mini',
            click: 'update',
            type: 'primary',
            icon: 'el-icon-update'
          }
        ]
      }
    }
  }
}
</script>
